<template>
  <MainTemplate>
    <MainNavbar
      slot="header"
      is-back-arrow-enabled
      has-small-logo
      :title="index"
    />
    <MainFooter slot="footer" />
    <b-container class="pt-4">
      <BaseLoading v-if="isPageLoading" />
      <div
        v-else
        v-html="content"
      />
    </b-container>
  </MainTemplate>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import MainTemplate from '@/layout/Templates/MainTemplate'
import MainNavbar from '@/layout/MainNavbar'
import MainFooter from '@/layout/MainFooter'
import BaseLoading from '@/components/Atoms/BaseLoading'

export default {
  name: 'StaticPage',
  components: {
    BaseLoading,
    MainFooter,
    MainNavbar,
    MainTemplate,
  },
  metaInfo() {
    return {
      title: this.$t(`page-titles.${this.index}`),
    }
  },
  props: {
    index: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState({
      isPageLoading: state => state['pages/staticPagesContent'].isPageLoading,
    }),
    page() {
      return this.$store.getters['pages/staticPagesContent/getPageByIndex']({ index: this.index })
    },
    content() {
      let content = false
      if (!this.isPageLoading && this.page) {
        content = this.page.content[this.$i18n.locale]
      }
      return content
    },
  },
  created() {
    this.fetchPageByIndex({ index: this.index })
  },
  methods: {
    ...mapActions({
      fetchPageByIndex: 'pages/staticPagesContent/fetchPageByIndex',
    }),
  },
}
</script>

<style scoped>

</style>
